export default "__VITE_ASSET__bdd40ac6__"